/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from "moment-business-days";
// import { addDays } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { CalendarMinus2, Plus, ChevronLeft, ChevronRight } from "lucide-react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { ListGroup } from "reactstrap";
// eslint-disable-next-line no-unused-vars
import { ticketStatusDates, queryDateFormat } from "../../../../config/constants";
import { BlurSpinner } from "../../../components/BlurSpinner";
import Breadcrumb from "../../../components/common/breadcrumb";
import { StaticTimeLine } from "../../../components/StaticTimeLine";
import { useAuth } from "../../../context/AuthContext";
import useFetcher from "../../../hooks/useFetcher";
import modulos from "../../../mocks/modulos";
import { fetchTicket, fetchTicketingCategories } from "../../../services/ticketingServices";
import "../styles.scss";
import ChatBox from "./ChatBox";
import ItemListConversation from "./ItemListConversation";
import NewConversation from "./NewConversation";
import Tabs from "./Tabs";
import { CircleButton } from "../../../ui/buttons";
import { TabsContainer, TabsToogle } from "../../NotasDePedidoDetail/styles";

const Inbox = ({ match, location, history }) => {
  const { currentUser, haveSucursalCasaCentralAsignada } = useAuth();
  const [ticketingCategories, isLoading] = useFetcher(fetchTicketingCategories, undefined, "fetchTicketingCategories");
  // eslint-disable-next-line no-unused-vars
  const [pagination] = useState(match.params.pagination || location.search);
  const ticketId = match.params.id;
  const [ticket, isLoadingTicket, , setTicketState, loadTicket] = useFetcher(fetchTicket, [ticketId, pagination]);
  const [conversationList, setConversationList] = useState([]);
  const [conversationSelectedId, setConversationSelectedId] = useState(null);
  const [newConversationToggle, setNewConversationToggle] = useState(false);
  const [showReplyMessage, setShowReplyMessage] = useState(false);
  const currentUserId = currentUser && currentUser.user.Pi.itemId;
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.TICKETING);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.TICKETING);
  const isOwner = ticket.personalInternoAsignado === currentUserId;
  const isWatcher = ticket && ticket.Watchers && ticket.Watchers.map((watcher) => watcher.itemId).includes(currentUserId);

  const isTeam = ticket && ticket.SucursaldepartamentoAsignado && haveSucursalCasaCentralAsignada(ticket.SucursaldepartamentoAsignado.itemId);
  // const colaboradores = (ticket && ticket.Colaboradores) || [];
  // const isColaborador = colaboradores.map((colaborador) => colaborador.itemId).includes(currentUserId);
  const canCreateConversation = ticket.editable && (isOwner || isWatcher || isAdmin || isTeam) && !isAudit;
  const activityComponent = useRef();
  const [anteriroId, setAnteriorId] = useState(null);
  const [siguienteId, setSiguienteId] = useState(null);
  const [showTabs, setShowTabs] = useState(true);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (ticket && ticket.anterior && ticket.anterior !== anteriroId) setAnteriorId(ticket.anterior);
    if (ticket && ticket.siguiente && ticket.siguiente !== siguienteId) setSiguienteId(ticket.siguiente);
  }, [ticket, ticketId]);

  const handleConversationSelected = (event, { id }) => {
    setNewConversationToggle(false);
    setShowReplyMessage(false);
    setConversationSelectedId(id);
  };

  const handleChangeReplyMessage = (isShow) => {
    setShowReplyMessage(isShow);
  };

  const handleFilesChange = () => {
    activityComponent.current.refreshActivities();
  };

  const addConversation = (newConversation) => {
    const conversationObj = {
      id: newConversation.conversationId,
      createdAt: newConversation.createdAt,
      subject: newConversation.subject,
      lastMessage: newConversation,
    };
    setConversationList([...conversationList, conversationObj]);
    handleConversationSelected(null, conversationObj);
  };

  const newConversationToggleHandler = () => {
    setNewConversationToggle(!newConversationToggle);
  };

  useEffect(() => {
    const conversaciones = ticket.conversaciones || [];
    const rootConversation = conversaciones ? conversaciones.find((c) => c.isRoot) : null;
    setConversationList(conversaciones);
    if (rootConversation) {
      setConversationSelectedId(rootConversation.id);
    }
  }, [ticket]);

  const timelineItems = [];

  if (ticketingCategories && ticketingCategories.status) {
    for (const status of ticketingCategories.status) {
      const dateField = ticketStatusDates[status.text];
      if (dateField && ticket[dateField.name]) {
        timelineItems.push({
          title: status.text,
          color: status.color,
          date: moment.utc(ticket[dateField.name]),
        });
      } else if (dateField && dateField.replaceToday) {
        timelineItems.push({
          title: "Hoy",
          color: "6699CC",
          date: moment.utc(),
        });
      }
    }
    if (ticket.prioridad) {
      const initialDate = ticket.fechaCreacionStart ? moment(new Date(ticket.fechaCreacionStart)).format(queryDateFormat) : null;
      // const daysToAdd = ticket.prioridadCat.text === "Alta" ? 5 : ticket.prioridadCat.text === "Media" ? 7 : 10;
      const daysToAdd =
        ticket.grupoSla !== 2
          ? ticket.prioridadCat.text === "Alta"
            ? 5
            : ticket.prioridadCat.text === "Media"
            ? 7
            : 10
          : ticket.prioridadCat.text === "Alta"
          ? 1
          : ticket.prioridadCat.text === "Media"
          ? 2
          : 3;
      const expirationDate = moment(initialDate).businessAdd(daysToAdd);
      timelineItems.push({
        title: "Vencimiento",
        color: "e8727f",
        date: moment.utc(expirationDate),
      });
    }
  }
  const handleReloadTicket = () => {
    loadTicket();
  };

  const handleToggle = () => {
    if (showTabs) {
      setClosing(true);
      setTimeout(() => {
        setShowTabs(false);
        setClosing(false);
      }, 200);
    } else {
      setShowTabs(true);
    }
  };
  const handleClickedRight = () => {
    history.push({
      pathname: `/ticketing/${siguienteId}/detail/${pagination}`,
    });
  };
  const handleClickedLeft = () => {
    history.push({
      pathname: `/ticketing/${anteriroId}/detail/${pagination}`,
    });
  };
  // Se agrega esta funcion para que el boton back funcione correctamente y
  // vuelva a la lista de tickets en vez de volver al ticket anterior
  const handleBackButton = () => {
    if (pagination) {
      history.push({
        pathname: `/ticketing`,
        search: pagination,
      });
    } else {
      history.push("/ticketing?mode=team");
    }
  };
  return (
    <>
      <Helmet>
        <title>PIN - Ticket {ticketId}</title>
      </Helmet>
      <Breadcrumb
        title={`Ticket ${ticket.fechaDerivadoStart ? "D" : ""}${ticketId}`}
        currentLevel="Ticket"
        parent="Sistema de Ticketing"
        backButton
        onBackButton={handleBackButton}
      >
        <StaticTimeLine items={timelineItems} />
      </Breadcrumb>
      <BlurSpinner isLoading={isLoading || isLoadingTicket}>
        <div className="container-fluid ticket-details p-0">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {ticket && anteriroId ? (
              <ChevronLeft onClick={handleClickedLeft} style={{ cursor: "pointer", margin: "5px", zIndex: "1", width: "30px", color: "var(--secondary)" }} />
            ) : (
              ""
            )}
            <div className="row" style={{ position: "relative", width: "100%", fontFamily: "Nunito" }}>
              <div className={!showTabs ? "col-lg-12 px-1" : "col-lg-9 px-2"}>
                <div className="row">
                  <div className="col-lg-4 pr-1">
                    <div className="card mb-2 full-height">
                      <div className="card-body chat-body p-3">
                        <div className="chat-box">
                          <div className="chat-left-aside">
                            <div className="d-flex justify-content-between pt-1 pb-3" style={{ borderBottom: "1px solid #293134" }}>
                              <div className="about d-flex">
                                <span className="pr-2">
                                  <CalendarMinus2 color="#f0292a" size={20} />
                                </span>
                                <h5 className="font-weight-bold font-size-18">Inbox</h5>
                              </div>
                              {canCreateConversation && (
                                <CircleButton type="button" size="25px" onClick={newConversationToggleHandler}>
                                  <Plus />
                                </CircleButton>
                              )}
                            </div>
                            <div className="people-list custom-scrollbar" style={{ height: "unset" }}>
                              <ListGroup className="list custom-scrollbar">
                                {!isLoadingTicket &&
                                  conversationList
                                    .sort((a, b) => {
                                      if (a.isRoot) return -1;
                                      return a.id - b.id;
                                    })
                                    .map((item) => (
                                      <ItemListConversation key={`key-${item.id}`} item={item} ticket={ticket} handleConversationSelected={handleConversationSelected} />
                                    ))}
                              </ListGroup>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 pl-1">
                    <div className="card mb-2 full-height">
                      {!newConversationToggle && conversationList.length > 0 && conversationSelectedId && (
                        <ChatBox
                          ticketId={ticketId}
                          ticket={ticket}
                          conversationSelectedId={conversationSelectedId}
                          isNewConversation={newConversationToggle}
                          isReplyMessage={showReplyMessage}
                          setIsReplyMessage={setShowReplyMessage}
                          handleFilesChange={handleFilesChange}
                          changeReplyMessage={handleChangeReplyMessage}
                          handleReloadTicket={handleReloadTicket}
                          isAudit={isAudit}
                        />
                      )}

                      <div>
                        {newConversationToggle && !isLoadingTicket && !isAudit && (
                          <NewConversation
                            ticketId={ticketId}
                            ticket={ticket}
                            addConversation={addConversation}
                            handleFilesChange={handleFilesChange}
                            setNewConversationToggle={setNewConversationToggle}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TabsContainer
                className={closing ? "slide-out" : "slide-in"}
                style={showTabs ? { minWidth: "25%", paddingLeft: "20px", flex: "0 0 25%" } : { minWidth: "0px" }}
              >
                <TabsToogle left="0px" type="button" onClick={handleToggle} aria-label="Close">
                  {showTabs ? <ChevronRight size="20" color="#F0292A" /> : <ChevronLeft size="20" color="#F0292A" />}
                </TabsToogle>
                {showTabs && (
                  <div>
                    <div className="card mb-2 full-height">
                      <div className="card-body p-2">
                        <Tabs
                          ticket={ticket}
                          ticketId={ticketId}
                          ticketingCategories={ticketingCategories}
                          setTicketState={setTicketState}
                          location={location}
                          history={history}
                          activityComponent={activityComponent}
                          isAudit={isAudit}
                          loadTicket={loadTicket}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </TabsContainer>
            </div>
            {ticket && siguienteId ? (
              <ChevronRight onClick={handleClickedRight} style={{ cursor: "pointer", margin: "5px", zIndex: "1", width: "30px", color: "var(--secondary)" }} />
            ) : (
              ""
            )}
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Inbox);
